import { useQuery } from '@tanstack/react-query';
import { adminApi } from 'src/services/api';

export type GetPractitionerWorkspaceListResponse = {
  organizations: {
    org_name: string;
    org_id: number;
    org_uuid: string;
    user_count: number;
    created_at: string;
  }[];
};

export const useGetPractitionerWorkspaceList = () => {
  return useQuery({
    queryKey: ['practitionerWorkspaceList'],
    queryFn: () =>
      adminApi
        .get<GetPractitionerWorkspaceListResponse>(`/practitioner/workspaces`)
        .then((res) => res.data),
  });
};
